import React, { forwardRef, useState } from "react";
import NotificationButton from "../notification-button/NotificationButton";
import NotificationsPanel from "../notifications-panel/NotificationsPanel";

const NotificationsContainer = forwardRef((_, ref) => {
  const [isPanelOpen, setPanelOpen] = useState(false);

  return (
    <>
      <NotificationButton onClick={() => setPanelOpen(true)} ref={ref} />
      <NotificationsPanel open={isPanelOpen} onClose={() => setPanelOpen(false)} />
    </>
  );
});

NotificationsContainer.displayName = "NotificationsContainer";

export default NotificationsContainer;
